import { render, staticRenderFns } from "./xiaofeng.vue?vue&type=template&id=9e1657f0"
import script from "./xiaofeng.vue?vue&type=script&lang=js"
export * from "./xiaofeng.vue?vue&type=script&lang=js"
import style0 from "./xiaofeng.vue?vue&type=style&index=0&id=9e1657f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports